import React, { useMemo } from 'react';
import { UIGameTimer } from './UIGameTimer.tsx';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { useGameValidator } from '../../store/selectors/useGameValidator.ts';
import { useIsGameEnded } from '../../store/selectors/useIsGameEnded.ts';
export const UIGameTimerContainer = ({ className })=>{
    const timeLeftInSeconds = useGameStore((state)=>state.timeLeftInSeconds);
    const isPaused = useGameStore((state)=>state.gamePause.isPaused);
    const gameValidator = useGameValidator();
    const myColor = useGameStore((state)=>state.myColor);
    const isGameEnded = useIsGameEnded();
    const isMyPlayerTakingAction = useMemo(()=>{
        if (isGameEnded) return false;
        const playersTakingAction = gameValidator.getPlayersTakingAction();
        return playersTakingAction.includes(myColor);
    }, [
        gameValidator,
        myColor
    ]);
    return /*#__PURE__*/ React.createElement(UIGameTimer, {
        className: className,
        timeLeftInSeconds: timeLeftInSeconds,
        isMyPlayerTakingAction: isMyPlayerTakingAction,
        isPaused: isPaused
    });
};
